var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i-menu',{staticStyle:{"height":"50px","width":"100%"},attrs:{"mode":"horizontal","active-name":_vm.sectionSelected},on:{"on-select":_vm.onSelect}},[_c('MenuItem',{attrs:{"name":"detail"}},[_vm._v("\n    Details\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }